module.exports = __webpack_public_path__ + "img/addicon1.4ce6f5f2.png";